@if(mode() === 'home') {
<ng-container *ngTemplateOutlet="homefilter"></ng-container>
} @else {
<ng-container *ngTemplateOutlet="nohomefilter"></ng-container>
}

<ng-template #homefilter>
    @switch (media) {
    @case ('xs') {
    <ng-container *ngTemplateOutlet="homemodeMobile"></ng-container>
    }
    @case ('sm') {
    <ng-container *ngTemplateOutlet="homemodeMobile"></ng-container>
    }
    @case ('md') {
    <ng-container *ngTemplateOutlet="homemodeMobile"></ng-container>
    }
    @default {
    <ng-container *ngTemplateOutlet="homefilterdesk"></ng-container>
    }
    }
</ng-template>

<ng-template #homefilterdesk>
    <div class="headercc1">
        @if(israiltravel()) {
        <div multilang [class.headercc2]="type === 'railtravel'" [class.headercc4]="type !== 'railtravel'"
            (click)="setBahn()">
            <div>{{'Bahnreisen' }}</div>
        </div>
        } @else {
        <div multilang [class.headercc2]="type === 'pauschal'" [class.headercc4]="type !== 'pauschal'"
            (click)="setPauschal()">
            <div>{{'Pauschalreisen' }}</div>
        </div>
        }
        <div multilang [class.headercc3]="type !== 'hotelonly'" [class.headercc2]="type === 'hotelonly'"
            (click)="setHotelonly()">
            <div>{{'Hotels' }}</div>
        </div>
    </div>
    <div class="tmp-inputs-wrapper">
        <div class="tmp-principal-wrapper">
            <clever-reiseziel [mode]="'home'" [type]="type" class="w270p"
                [completion]="completion()"></clever-reiseziel>
            @if(type === 'pauschal') {
            <clever-airport [mode]="'home'"></clever-airport>
            }
            @if(type === 'railtravel') {
            <clever-reil [mode]="'home'"></clever-reil>
            }
            @if(type === 'hotelonly') {
            <clever-roomtype [mode]="'home'"></clever-roomtype>
            }
            <clever-date [start]="start" [end]="end" (selectValue)="selectValue($event)" [mode]="'home'"
                class="w300px"></clever-date>
            <clever-dauer [mode]="'home'"></clever-dauer>
            <clever-traveller [mode]="'home'" (sendRes)="resTraveler($event)"
                [reisende]="filter?.reisendeResult"></clever-traveller>
            <button multilang deeplMode="tooltip" matTooltip="mehr filter" aria-label="Mehr Filter"
                (click)="openclosemore()" matRipple>
                <mat-icon fontIcon="more_vert"></mat-icon>
            </button>
            <button class="tmpsearch tmpbtn tmp-left tmp-right" (click)="gotoZiel(true)" matRipple>
                <mat-icon fontIcon="search"></mat-icon>
                <span multilang>{{btntext }}</span>
            </button>
        </div>
        <ng-container *ngIf="showMore" [ngTemplateOutlet]="moreFilter"></ng-container>
    </div>
</ng-template>

<ng-template #homemodeMobile>
    <div class="tmp-inputs-wrapper-mobile">
        <div class="headercc1mobile">
            @if(israiltravel()) {
            <div [class.headercc2mobile]="type === 'pauschal'" [class.headercc4mobile]="type !== 'pauschal'"
                (click)="setBahn()">
                <div multilang>{{'Bahnreisen' }}</div>
            </div>
            } @else {
            <div [class.headercc2mobile]="type === 'pauschal'" [class.headercc4mobile]="type !== 'pauschal'"
                (click)="setPauschal()">
                <div multilang>{{'Pauschalreisen' }}</div>
            </div>
            }
            <div [class.headercc3mobile]="type !== 'hotelonly'" [class.headercc2mobile]="type === 'hotelonly'"
                (click)="setHotelonly()">
                <div multilang>{{'Hotels' }}</div>
            </div>
        </div>
        <div class="tmp-extrafilter-wraper-mobile w100">
            <div class="extras">
                <clever-reiseziel [mode]="'home'" [type]="type" class="w100"
                    [completion]="completion()"></clever-reiseziel>
                <clever-date [start]="start" [end]="end" (selectValue)="selectValue($event)" [mode]="'home'"
                    class="w100"></clever-date>
                <div class="gr-btn-mobile w100">
                    <ng-container *ngIf="type === 'pauschal'">
                        <clever-airport [mode]="'home'" class="w25"></clever-airport>
                    </ng-container>
                    <ng-container *ngIf="type === 'railtravel'">
                        <clever-reil [mode]="'home'" class="w25"></clever-reil>
                    </ng-container>
                    <ng-container *ngIf="type === 'hotelonly'">
                        <clever-roomtype [mode]="'home'" class="w25"></clever-roomtype>
                    </ng-container>
                    <clever-dauer [mode]="'home'" class="w50-mobile"></clever-dauer>
                    <clever-traveller [mode]="'home'" class="w25" (sendRes)="resTraveler($event)"
                        [reisende]="filter?.reisendeResult"></clever-traveller>
                </div>
            </div>

            <ng-container *ngIf="showMore" [ngTemplateOutlet]="moreFilterMobile"></ng-container>
            <button multilang deeplMode="tooltip" matTooltip="mehr filter" aria-label="Mehr Filter"
                class="tmp-mehrfilter-mobile" (click)="openclosemore()" matRipple>
                <mat-icon>more_horiz</mat-icon>
            </button>
            <button class="tmpsearch tmpsearch-mobile tmpbtn w100 tmp-left tmp-right" (click)="gotoZiel(true)"
                matRipple>
                <mat-icon fontIcon="search"></mat-icon>
                <span multilang>{{btntext }}</span>
            </button>
        </div>
    </div>
</ng-template>

<ng-template #nohomefilter>
    @switch (media) {
    @case ('xs') {
    <ng-container *ngTemplateOutlet="nohomemodeMobile"></ng-container>
    }
    @case ('sm') {
    <ng-container *ngTemplateOutlet="nohomemodeMobile"></ng-container>
    }
    @default {
    <ng-container *ngTemplateOutlet="nohomefilterdesk"></ng-container>
    }
    }
</ng-template>


<ng-template #nohomemodeMobile>
    @if(!onlyfilterandhotel()) {
    <div class="tmp-inputs-wrapper-nohome-mobile">
        <div class="smallfilter-mobile-wrapper mat-elevation-z1" (click)="showMBMenu()">
            <div class="m05 cc1">
                <span multilang class="smallfilter-title">
                    <clever-reiseziel [mode]="'nohomesmall'" [type]="type"
                        [completion]="completion()"></clever-reiseziel>
                </span>
                <div class="smallfilter-body">
                    <span multilang class="smallitem">
                        <clever-date [start]="start" [end]="end" (selectValue)="selectValue($event)"
                            [mode]="'nohomesmall'"></clever-date> |
                    </span>
                    <span multilang class="smallitem">
                        <clever-dauer [mode]="'nohomesmall'"></clever-dauer> |
                    </span>
                    <span multilang class="smallitem">
                        <clever-traveller [mode]="'nohomesmall'" (sendRes)="resTraveler($event)"
                            [reisende]="filter?.reisendeResult"></clever-traveller> P |
                    </span>
                    <span multilang class="smallitem">
                        <ng-container *ngIf="type === 'pauschal'">
                            <clever-airport [mode]="'nohomesmall'"></clever-airport>
                        </ng-container>
                        <ng-container *ngIf="type === 'railtravel'">
                            <clever-reil [mode]="'nohomesmall'"></clever-reil>
                        </ng-container>
                        <ng-container *ngIf="type === 'hotelonly'">
                            <clever-roomtype [mode]="'nohomesmall'"></clever-roomtype>
                        </ng-container>
                    </span>
                </div>
            </div>
            <button class="smallfilter-btn" (click)="showMBMenu()" matRipple>
                <mat-icon fontIcon="search"></mat-icon>
            </button>
        </div>
    </div>
    }
    <div cdkOverlayOrigin #mgfilterorg="cdkOverlayOrigin">
        <ng-template cdkConnectedOverlay [cdkConnectedOverlayFlexibleDimensions]="true"
            [cdkConnectedOverlayOrigin]="mgfilterorg" [cdkConnectedOverlayOpen]="smallVersion"
            [cdkConnectedOverlayHasBackdrop]="true">
            <div class="smallfilterbig-mobile-wrapper">
                <ng-container *ngTemplateOutlet="switchbtn"></ng-container>
                <clever-reiseziel [mode]="'nohome'" [type]="type" class="w100"
                    [completion]="completion()"></clever-reiseziel>
                <clever-date [start]="start" [end]="end" (selectValue)="selectValue($event)" [mode]="'nohome'"
                    class="w100"></clever-date>
                <ng-container *ngIf="type === 'pauschal'">
                    <clever-airport [mode]="'nohome'" [norightborder]="false" [bottomleftradius]="false"
                        class="w100"></clever-airport>
                </ng-container>
                <ng-container *ngIf="type === 'railtravel'">
                    <clever-reil [mode]="'nohome'" class="w100"></clever-reil>
                </ng-container>
                <div class="tmp-custsection">
                    <clever-dauer [mode]="'nohome'" class="w50"></clever-dauer>
                    <clever-traveller [mode]="'nohome'" class="w50" (sendRes)="resTraveler($event)"
                        [reisende]="filter?.reisendeResult"></clever-traveller>
                </div>
                <div class="btnwrpmb">
                    <button class="tmpbtn w50btn-mobile tmp-left tmp-right" (click)="closeMenu()" matRipple>
                        <span multilang>{{'Schließen' }}</span>
                    </button>
                    <button class="tmpsearch tmpbtn w50btn-mobile tmp-left tmp-right" (click)="gotoZiel(false)"
                        matRipple>
                        <mat-icon fontIcon="search"></mat-icon>
                        <span multilang>{{'Suche' }}</span>
                    </button>
                </div>
            </div>
        </ng-template>
    </div>
</ng-template>

<ng-template #nohomefilterdesk>
    <div class="tmp-inputs-wrapper-nohome">
        <ng-container *ngTemplateOutlet="switchbtn"></ng-container>
        <clever-reiseziel [mode]="'nohome'" [type]="type" class="w100" [completion]="completion()"></clever-reiseziel>
        <clever-date [start]="start" [end]="end" (selectValue)="selectValue($event)" [mode]="'nohome'"
            class="w100"></clever-date>
        <ng-container *ngIf="type === 'pauschal'">
            <clever-airport [mode]="'nohome'" class="w100" [norightborder]="false"
                [bottomleftradius]="false"></clever-airport>
        </ng-container>
        <ng-container *ngIf="type === 'railtravel'">
            <clever-reil [mode]="'nohome'" class="w100"></clever-reil>
        </ng-container>
        <div class="tmp-custsection">
            <clever-dauer [mode]="'nohome'" class="w50"></clever-dauer>
            <clever-traveller [mode]="'nohome'" class="w50" (sendRes)="resTraveler($event)"
                [reisende]="filter?.reisendeResult"></clever-traveller>
        </div>
        <button class="tmpsearch tmpsearch-mobile tmpbtn w100 tmp-left tmp-right" (click)="gotoZiel(false)" matRipple>
            <mat-icon fontIcon="search"></mat-icon>
            <span multilang>{{btntext }}</span>
        </button>
    </div>
</ng-template>

<ng-template #moreFilterMobile>
    <clever-hotelextrafilter [mode]="'home'" [type]="type" class="w100" (closeModal)="openclosemore()">
    </clever-hotelextrafilter>
</ng-template>

<ng-template #moreFilter>
    <clever-hotelextrafilter [mode]="'home'" [type]="type" class="w100" (closeModal)="openclosemore()">
    </clever-hotelextrafilter>
</ng-template>

<ng-template #switchbtn>
    <div class="w100 switchwrp tmp-top">
        @if(israiltravel()) {
        <button class="switchbtn btl nbb" [class.activeType]="type === 'railtravel'" (click)="switchTo('railtravel')"
            multilang>{{'Bahnreisen' }}</button>
        } @else {
        <button class="switchbtn btl nbb" [class.activeType]="type === 'pauschal'" (click)="switchTo('pauschal')"
            multilang>{{'Pauschalreisen' }}</button>
        }
        <button class="switchbtn btr nbb" [class.activeType]="type === 'hotelonly'" (click)="switchTo('hotelonly')"
            multilang>{{'Nur Hotel' }}</button>
    </div>
</ng-template>